
import {
  BlockBackgroundImage,
  BlockText,
} from '../implementations';

const mappers = {
  background_image: BlockBackgroundImage,
  text: BlockText,
};

export default mappers;

